<template>
    <!-- App -->
    <div id="app" class="color-theme-black">
        <global-loading></global-loading>
        <local-loading></local-loading>
        <custom-loading :showLoading="showLoading" :loadingMsg="loadingMsg"></custom-loading>
        <f7-app :params='f7params'>
            <f7-statusbar></f7-statusbar>
            <!-- :push-state="true" pushStateSeparator="#"-->
            <f7-view :push-state="true" main url="/index" pushStateSeparator="#">
            </f7-view>
        </f7-app>
    </div>
</template>
<script>
  import GlobalLoading from 'components/globalloading/globalLoading.vue'
  import LocalLoading from 'components/loading/Loading'
  import customLoading from 'components/customLoading/Loading'
  import { f7App, f7Statusbar, f7View, f7Link } from 'framework7-vue'
  import routes from './router/router'
  import { bus } from 'src/main'

  export default {
    data () {
      return {
        showLoading: false,
        loadingMsg: '',
        f7params: {
          routes,
          name: 'downloader',
          id: '',
          theme: 'ios',
          lazyModulesPath: 'https://maiya-res.oss-cn-shenzhen.aliyuncs.com/framework7-V3/lazy-components',
          touch: {
            fastClicks: false
          },
          dialog: {
            title: '友情提示',
            buttonOk: '确定',
            buttonCancel: '取消'
          }
        }
      }
    },
    created: function () {
      console.log('bus', bus)
      bus.$on('customLoading', (obj) => {
        let {showLoading, loadingMsg} = obj
        this.showLoading = showLoading
        this.loadingMsg = loadingMsg
      })
    },
    mounted () {
      this.$nextTick(() => {
        // this.$f7.loadModules(['dialog', 'popup'])
      })
    },
    methods: {
      goHome () {
      }
    },
    computed: {},
    components: {LocalLoading, GlobalLoading, f7App, f7Statusbar, f7View, f7Link, customLoading},
    destroyed () {
      bus.$off('customLoading')
    },
  }
</script>
<style lang="scss" type="text/css">
    @import "css/global.scss";
</style>
